import { render, staticRenderFns } from "./StudentClubSelectbox.vue?vue&type=template&id=59fdafac"
import script from "./StudentClubSelectbox.vue?vue&type=script&lang=js"
export * from "./StudentClubSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports